module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01-jp.94c0b0f8079a7adb5b20ed419fba23e0.png";